export default __webpack_public_path__ + "static/media/technologymain.ae80e15d.PNG";